import request from "@/api/request";

export function listArticle(query) {
  return request({
    url: '/article/articleTable/list',
    method: 'get',
    params: query
  })
}

// 新增客户留言
export function addCustomerTable(data) {
  return request({
    url: '/customer/customerTable',
    method: 'post',
    data: data
  })
}

export function listProcessTable(query) {
  return request({
    url: '/process/processTable/list',
    method: 'get',
    params: query
  })
}

// 查询新闻列表
export function listNewsTable(query) {
  return request({
    url: '/news/newsTable/list',
    method: 'get',
    params: query
  })
}

// 查询公司信息详细
export function getInformationTable(informationId) {
  return request({
    url: '/information/informationTable/' + informationId,
    method: 'get'
  })
}

// 查询资质管理列表
export function listQualificationsTable(query) {
  return request({
    url: '/qualifications/qualificationsTable/list',
    method: 'get',
    params: query
  })
}

// 查询产品信息列表
export function listProductTable(query) {
  return request({
    url: '/product/productTable/list',
    method: 'get',
    params: query
  })
}

// 查询产品信息详细
export function getProductTable(productId) {
  return request({
    url: '/product/productTable/' + productId,
    method: 'get'
  })
}

// 查询分类列表
export function listTable(query) {
  return request({
    url: '/classification/table/list',
    method: 'get',
    params: query
  })
}

// 查询新闻分类列表
export function listNewsClassification(query) {
  return request({
    url: '/newsClassification/table/list',
    method: 'get',
    params: query
  })
}

// 查询合作伙伴列表
export function listPartnerTable(query) {
  return request({
    url: '/partner/partnerTable/list',
    method: 'get',
    params: query
  })
}

// 查询系统详细
export function getInformonitorTable(monitorId) {
  return request({
    url: '/monitor/monitorTable/' + monitorId,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js